import { Card, CardContent, CardHeader, Skeleton, Typography } from '@mui/material';
import { t } from 'i18next';

const RowSkeleton = (props: { label: string; valueWidth: number }) => {
  return (
    <Typography variant="body1" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
      <Skeleton sx={{ mr: 1 }}>
        <span style={{ whiteSpace: 'nowrap' }}>{props.label}</span>
      </Skeleton>
      <Skeleton width={props.valueWidth} />
    </Typography>
  );
};

export const ReportDetailsSkeleton = () => {
  return (
    <Card data-role="report-details">
      <CardHeader title={t('reportDetails')} titleTypographyProps={{ variant: 'h6' }} sx={{ pb: 0 }} />
      <CardContent>
        <RowSkeleton label={t('reportName')} valueWidth={650} />
        <RowSkeleton label={t('version')} valueWidth={500} />
        <RowSkeleton label={t('size')} valueWidth={150} />
        <RowSkeleton label={t('traceUsed')} valueWidth={300} />
        <RowSkeleton label={t('profileUsed')} valueWidth={300} />
      </CardContent>
    </Card>
  );
};
